export default "__VITE_ASSET__3625f8db__"